import "./DiscussionComment.css";
import { Grid2, TextField } from "@mui/material";
import { ReactElement } from "react";
import Message from "../interfaces/Message";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

interface DiscussionCommentProps {
  message: Message;
}

export default function DiscussionComment({
  message
}: DiscussionCommentProps): ReactElement {
  return (
    <Grid2 size={7}>
      <span className="discussion-comment-author">{message.author}</span> commented on {dayjs(message.createdAt + "Z").local().format("YYYY-MM-DD hh:mm A")}:<br />
      <TextField multiline rows={6} variant="standard" className="txt-area" sx={{ width: "100%", height: 120 }} value={message.text} disabled />
    </Grid2>
  );
}
